<mat-dialog-content style="max-height: 57vh;">
  <div style="padding: 20px;">
    <div fxLayout="column">
      <div *ngIf="this.state == 'LOAD'" fxLayout="row wrap">

        <div fxFlex="100" fxLayoutAlign="center center">
          <div *ngIf="state === 'LOAD'" class="d-flex justify-content-center align-items-center">
            <img src="../../../assets/img/loading.gif" alt="Cargando categorías">
          </div>
        </div>


        <div fxLayoutAlign="center center" fxFlex="100" class="mt-10">
          <h2>{{ "TRANSLATE.PROSESSIONG_PAYMENT" | translate }} ...</h2>
        </div>
      </div>
      <div *ngIf="this.state == 'SUCCESS'" fxLayout="row wrap">
        <div fxFlex="100" fxLayoutAlign="center center">
          <mat-icon
            style="
              font-size: 73px;
              height: auto;
              width: auto;
              color: rgb(22, 185, 49);
            "
            >check_circle</mat-icon
          >
        </div>
        <div fxLayoutAlign="center center" fxFlex="100" class="mt-10">
          <h4>
            {{ "TRANSLATE.PAYMENT_SUCCESSFYLLY" | translate }}
          </h4>
        </div>
        <div fxLayoutAlign="center center" fxFlex="100" class="mt-10">
          <button
            class="btn-load text-light"
            mat-raised-button
            (click)="closeSuccess()"
          >
            {{ "TRANSLATE.ACCEPT" | translate }}
          </button>
        </div>
      </div>
      <div *ngIf="this.state == 'DUPLICATE'" fxLayout="row wrap">
        <div fxFlex="100" fxLayoutAlign="center center">
          <mat-icon
            style="font-size: 73px; height: auto; width: auto"
            color="primary"
            >warning</mat-icon
          >
        </div>
        <div fxLayoutAlign="center center" fxFlex="100" class="mt-10">
          <h4>
            {{this.messageError}}
          </h4>
        </div>
        <div fxLayoutAlign="center center" fxFlex="100" class="mt-10">
          <button
            class="btn-load text-light"
            mat-raised-button
            (click)="closeSuccess()"
          >
            {{ "TRANSLATE.ACCEPT" | translate }}
          </button>
        </div>
      </div>
      <div *ngIf="this.state == 'ERROR'" fxLayout="row wrap">
        <div fxFlex="100" fxLayoutAlign="center center">
          <mat-icon
            style="font-size: 73px; height: auto; width: auto"
            color="warn"
            >error</mat-icon
          >
        </div>
        <div fxLayoutAlign="center center" fxFlex="100" class="mt-10">
          <h4>
            {{this.messageError}}
          </h4>
        </div>
        <div fxLayoutAlign="center center" fxFlex="100" class="mt-10">
          <button color="primary" mat-raised-button (click)="closeSuccess()">
            {{ "TRANSLATE.TRY_AGAIN" | translate }}
          </button>
        </div>
      </div>
      <div *ngIf="this.state == 'EXPIRED'" fxLayout="row wrap">
        <div fxFlex="100" fxLayoutAlign="center center">
          <mat-icon
            style="font-size: 73px; height: auto; width: auto"
            color="warn"
            >assignment_late</mat-icon
          >
        </div>
        <div fxLayoutAlign="center center" fxFlex="100" class="mt-10">
          <h4>
            {{ "TRANSLATE.PAYMENT_TIMEOUNT" | translate }}
          </h4>
        </div>
        <div
          fxLayout="row"
          fxLayout.xs="column"
          fxLayoutAlign="space-between center"
          fxFlex="100"
          class="mt-10"
        >
          <button
            ngClass.xs="mt-10"
            color="primary"
            mat-raised-button
            (click)="closeSuccess()"
          >
            {{ "TRANSLATE.TRY_AGAIN" | translate }}
          </button>
          <span></span>
          <button
            ngClass.xs="mt-10"
            color="primary"
            mat-raised-button
            (click)="irMisPedidos()"
          >
            {{ "TRANSLATE.GO_MY_ORDERS" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

</mat-dialog-content>
